import React, { FC, createContext, useState, useMemo, useContext } from 'react';
type AlternativeItineraryLayerActionsContextType = {
  open: () => void;
  close: () => void;
  showErrorLayer: () => void;
  setFeeType: (feeType: string) => void;
};
type AlternativeItineraryLayerContextType = {
  isOpen: boolean;
  isErrorLayerVisible: boolean;
  isDesktopEnabled: boolean;
  feeTypeSelected: string | null;
};
const AlternativeItineraryLayerContext =
  createContext<AlternativeItineraryLayerContextType>({
    isOpen: false,
    isErrorLayerVisible: false,
    isDesktopEnabled: false,
    feeTypeSelected: null,
  });
const AlternativeItineraryLayerActionsContext = createContext({
  open: () => {},
  close: () => {},
  showErrorLayer: () => {},
  setFeeType: (_feeType: string) => {},
});
const AlternativeItineraryLayerProvider: FC<{
  isDesktopEnabled: boolean;
}> = ({ isDesktopEnabled = false, children }) => {
  const [isOpen, setOpen] = useState(false);
  const [isErrorLayerVisible, setIsErrorLayerVisible] = useState(false);
  const [feeTypeSelected, setFeeTypeSelected] = useState<string | null>(null);
  const actions = useMemo(
    () => ({
      open: (): void => setOpen(true),
      close: (): void => {
        setOpen(false);
        setIsErrorLayerVisible(false);
      },
      showErrorLayer: (): void => setIsErrorLayerVisible(true),
      setFeeType: (feeType: string): void => setFeeTypeSelected(feeType),
    }),
    [setOpen]
  );
  return (
    <AlternativeItineraryLayerContext.Provider
      value={{ isOpen, isErrorLayerVisible, isDesktopEnabled, feeTypeSelected }}
    >
      <AlternativeItineraryLayerActionsContext.Provider value={actions}>
        {children}
      </AlternativeItineraryLayerActionsContext.Provider>
    </AlternativeItineraryLayerContext.Provider>
  );
};
export const useIsAlternativeItineraryLayerOpen =
  (): AlternativeItineraryLayerContextType =>
    useContext(AlternativeItineraryLayerContext);
export const useAlternativeItineraryLayerActions =
  (): AlternativeItineraryLayerActionsContextType =>
    useContext(AlternativeItineraryLayerActionsContext);
export const useIsAlternativeItineraryDesktopEnabled = (): boolean => {
  const { isDesktopEnabled } = useIsAlternativeItineraryLayerOpen();
  return isDesktopEnabled;
};
export default AlternativeItineraryLayerProvider;
